import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

const rebuild = (state) => {
    state.cache = {};
    
    _.forEach(state.viewData, (data, _index) => {
        if (data && data.references) {
            _.forEach(data.references, (_refs, instanceSOP) => {
                delete state.cache[instanceSOP];
            });
        }
    });

    _.forEach(state.viewData, (data, index) => {
        if (data && data.references) {
            _.forEach(data.references, (refs, instanceSOP) => {
                if (!state.cache[instanceSOP]) {
                    state.cache[instanceSOP] = [];
                }
                state.cache[instanceSOP].push({
                    index: index,
                    currentPage: state.viewCurrentPage[index],
                    refs
                });
            });
        }
    });
}

export const viewsSlice = createSlice({
    name: "views",
    initialState: {
        viewCurrentPage: [],
        viewData: [],
        cache: {}
    },
    reducers: {
        // setGlobalVariable: (state, variable) => {
        //     state.variables[variable.payload.name] = variable.payload.value;
        // },
        // updateScroll: (state) => {
        //     state.variables.scrollCount++;
        // },
        // clearViewersData: (state) => {
        //     let currentIndex = 1;
        //     while (true) {
        //         //
        //         const variableName = "toolbarViewer" + currentIndex;
        //         if (state.variables.hasOwnProperty(variableName)) {
        //             delete state.variables[variableName];
        //         } else
        //             break;
        //         currentIndex++;
        //     }
        //     delete state.variables.toolbarViewerQuickAction;
        // },
        
        setViewCurrentPage: (state, currentPage) => {
            state.viewCurrentPage[currentPage.payload.index] = currentPage.payload.page;

            rebuild(state);
        },
        setViewData: (state, viewData) => {
            state.viewData[viewData.payload.index] = viewData.payload.data;

            rebuild(state);
        },
    },
});

export const { setViewData, setViewCurrentPage, setCacheForId } = viewsSlice.actions;
export const getViewCurrentPage = state => state.views.viewCurrentPage;

export const referenceForSOP = (instanceSOP) => {
    return state => {
        let founded = undefined;
        if (instanceSOP) {
            if (state.views.cache[instanceSOP]) {
                founded = state.views.cache[instanceSOP];
            }
        }

        return founded;
    };
};

// export const globalVariable = (name) => {
//     return state => state.globals.variables[name];
// };
// export const onUpdateScroll = state => state.globals.variables.scrollCount;

export default viewsSlice.reducer;
